// МОдальное окно добавления измерений прочности бетона фундаментов
// AddConcreteMeasurements.jsx
import React, { useState } from 'react';
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CForm,
  CRow,
  CCol,
  CFormLabel,
  CFormInput,
  CFormSelect,
  CTable,
  CTableHead,
  CTableBody,
  CTableHeaderCell,
  CTableRow,
  CTableDataCell,
  CInputGroup
} from '@coreui/react';
import { cilPlus } from '@coreui/icons';
import CIcon from '@coreui/icons-react';

const AddConcreteMeasurements = ({ visible, onClose, onSave }) => {
  const [foundationType, setFoundationType] = useState('Анкерный');
  const [foundationDesignationFirst, setFoundationDesignationFirst] = useState('');
  const [foundationDesignationSecond, setFoundationDesignationSecond] = useState('');
  const [constructionFragment, setConstructionFragment] = useState('');
  const [testArea, setTestArea] = useState('Надземная часть');
  const [protectiveCoating, setProtectiveCoating] = useState('');
  const [projectConcreteGrade, setProjectConcreteGrade] = useState('');
  const [projectConcreteClass, setProjectConcreteClass] = useState('');
  const [measurements, setMeasurements] = useState([
    { id: 1, number: 1, speed: '' }
  ]);

  const handleSave = () => {
    const measurementData = {
      foundationType,
      foundationDesignation: `${foundationDesignationFirst}-${foundationDesignationSecond}`,
      constructionFragment,
      testArea,
      protectiveCoating,
      projectConcreteGrade,
      projectConcreteClass,
      measurements
    };
    onSave(measurementData);
    resetForm();
    onClose();
  };

  const resetForm = () => {
    setFoundationType('Анкерный');
    setFoundationDesignationFirst('');
    setFoundationDesignationSecond('');
    setConstructionFragment('');
    setTestArea('Надземная часть');
    setProtectiveCoating('');
    setProjectConcreteGrade('');
    setProjectConcreteClass('');
    setMeasurements([{ id: 1, number: 1, speed: '' }]);
  };

  const handleAddMeasurement = () => {
    const newId = measurements.length > 0 ? Math.max(...measurements.map(m => m.id)) + 1 : 1;
    const newNumber = measurements.length + 1;
    setMeasurements([...measurements, { id: newId, number: newNumber, speed: '' }]);
  };

  const handleDeleteMeasurement = () => {
    if (measurements.length > 1) {
      const updatedMeasurements = [...measurements];
      updatedMeasurements.pop();
      setMeasurements(updatedMeasurements);
    }
  };

  const handleSpeedChange = (id, value) => {
    setMeasurements(measurements.map(measurement => 
      measurement.id === id ? { ...measurement, speed: value } : measurement
    ));
  };

  return (
    <CModal visible={visible} onClose={onClose} size="lg">
      <CModalHeader>
        <CModalTitle>Прочность бетона</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CForm>
          <CRow className="mb-3">
            <CCol md="4">
              <CFormLabel htmlFor="foundationType">Фундамент</CFormLabel>
            </CCol>
            <CCol md="8">
              <CFormSelect
                id="foundationType"
                value={foundationType}
                onChange={(e) => setFoundationType(e.target.value)}
              >
                <option value="Анкерный">Анкерный</option>
                <option value="Центральный">Центральный</option>
                <option value="Фундамент">Фундамент</option>
              </CFormSelect>
            </CCol>
          </CRow>

          <CRow className="mb-3 align-items-center">
            <CCol md="4">
              <CFormLabel>Обозначение фундамента</CFormLabel>
            </CCol>
            <CCol md="8" className="d-flex align-items-center">
              <CFormInput
                type="text"
                value={foundationDesignationFirst}
                onChange={(e) => setFoundationDesignationFirst(e.target.value)}
                placeholder="Часть 1"
                style={{ width: '100px' }}
              />
              <span className="mx-2">-</span>
              <CFormInput
                type="text"
                value={foundationDesignationSecond}
                onChange={(e) => setFoundationDesignationSecond(e.target.value)}
                placeholder="Часть 2"
                style={{ width: '100px' }}
              />
            </CCol>
          </CRow>

          <CRow className="mb-3">
            <CCol md="4">
              <CFormLabel>Конструкция фрагмента</CFormLabel>
            </CCol>
            <CCol md="8">
              <CInputGroup>
                <CFormInput
                  type="text"
                  value={constructionFragment}
                  onChange={(e) => setConstructionFragment(e.target.value)}
                  placeholder="Введите конструкцию фрагмента"
                />
                <CButton
                  type="button"
                  color="primary"
                  variant="outline"
                  onClick={() => console.log('Открыть модальное окно выбора конструкции')}
                  style={{ maxHeight: '38px' }}
                >
                  <CIcon icon={cilPlus} />
                </CButton>
              </CInputGroup>
            </CCol>
          </CRow>

          <CRow className="mb-3">
            <CCol md="4">
              <CFormLabel htmlFor="testArea">Участок испытания</CFormLabel>
            </CCol>
            <CCol md="8">
              <CFormSelect
                id="testArea"
                value={testArea}
                onChange={(e) => setTestArea(e.target.value)}
              >
                <option value="Надземная часть">Надземная часть</option>
                <option value="Подземная часть">Подземная часть</option>
              </CFormSelect>
            </CCol>
          </CRow>

          <CRow className="mb-3">
            <CCol md="4">
              <CFormLabel>Защитное покрытие фундамента</CFormLabel>
            </CCol>
            <CCol md="8">
              <CInputGroup>
                <CFormInput
                  type="text"
                  value={protectiveCoating}
                  onChange={(e) => setProtectiveCoating(e.target.value)}
                  placeholder="Введите защитное покрытие"
                />
                <CButton
                  type="button"
                  color="primary"
                  variant="outline"
                  onClick={() => console.log('Открыть модальное окно выбора покрытия')}
                  style={{ maxHeight: '38px' }}
                >
                  <CIcon icon={cilPlus} />
                </CButton>
              </CInputGroup>
            </CCol>
          </CRow>

          <CRow className="mb-3">
            <CCol md="4">
              <CFormLabel htmlFor="projectConcreteGrade">Проектная марка бетона</CFormLabel>
            </CCol>
            <CCol md="8">
              <CFormSelect
                id="projectConcreteGrade"
                value={projectConcreteGrade}
                onChange={(e) => setProjectConcreteGrade(e.target.value)}
              >
                <option value="">Выберите марку</option>
                {/* Опции будут добавлены позже */}
              </CFormSelect>
            </CCol>
          </CRow>

          <CRow className="mb-3">
            <CCol md="4">
              <CFormLabel htmlFor="projectConcreteClass">Проектный класс бетона</CFormLabel>
            </CCol>
            <CCol md="8">
              <CFormSelect
                id="projectConcreteClass"
                value={projectConcreteClass}
                onChange={(e) => setProjectConcreteClass(e.target.value)}
              >
                <option value="">Выберите класс</option>
                {/* Опции будут добавлены позже */}
              </CFormSelect>
            </CCol>
          </CRow>

          <div className="mb-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <CFormLabel>Измерения скорости ультразвука</CFormLabel>
              <div>
                <CButton 
                  color="secondary" 
                  size="sm" 
                  className="me-2" 
                  onClick={handleAddMeasurement}
                >
                  Добавить
                </CButton>
                <CButton 
                  color="secondary" 
                  size="sm" 
                  onClick={handleDeleteMeasurement}
                >
                  Удалить
                </CButton>
              </div>
            </div>
            <CTable bordered responsive>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell>№ измерения</CTableHeaderCell>
                  <CTableHeaderCell>Средняя скорость прохождения ультразвука, м/с</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {measurements.map((measurement) => (
                  <CTableRow key={measurement.id}>
                    <CTableDataCell>{measurement.number}</CTableDataCell>
                    <CTableDataCell>
                      <CFormInput
                        type="text"
                        value={measurement.speed}
                        onChange={(e) => handleSpeedChange(measurement.id, e.target.value)}
                        placeholder="Введите скорость"
                      />
                    </CTableDataCell>
                  </CTableRow>
                ))}
              </CTableBody>
            </CTable>
          </div>
        </CForm>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Отмена
        </CButton>
        <CButton color="primary" onClick={handleSave}>
          Сохранить
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default AddConcreteMeasurements;